module.exports = __webpack_public_path__ + "img/12_80.c4dd7e02.png";